import { render, staticRenderFns } from "./website-component.vue?vue&type=template&id=73f0f17b&"
import script from "./website-component.vue?vue&type=script&lang=js&"
export * from "./website-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports